import { render, staticRenderFns } from "./privacyXt.vue?vue&type=template&id=17a034d2&"
import script from "./privacyXt.vue?vue&type=script&lang=js&"
export * from "./privacyXt.vue?vue&type=script&lang=js&"
import style0 from "./privacyXt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports